import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSimCard1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSimCard1"><Path d="M10 16V13H14V16H10Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M4 22V2H14.4142L20 7.58579V22H4ZM8 11V18H16V11H8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSimCard1;
